import React from 'react'
import { MultiSelect } from 'primereact/multiselect';
import './multiselect.css'

function MultiSelectDropDown({sx,value="" ,options,placeholder="",optionLabel="label",optionValue,handleMultiselectChange,...restProps}) {

    // console.log("value",value)
    // console.log("userRoleData",options)

  return (
    <MultiSelect 
    style={sx?sx:{width:"100%"}}
    value={value||[]} 
    onChange={(e) =>handleMultiselectChange(e.value,e)}
    optionValue={optionValue}
    options={options||[]} 
    optionLabel={optionLabel}
    placeholder={placeholder}  {...restProps}/>
  )
}

export default MultiSelectDropDown